import { memo } from 'react';

import { Button, Flex, Typography } from 'antd';

import { ExportOutlined } from '@ant-design/icons';

import styles from './styles.module.scss';

const { Text } = Typography;
function FooterLink({ to, label }) {
  return (
    <Button
      type="link"
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      iconPosition="end"
      icon={<ExportOutlined />}
      className={styles['footer-link']}>
      {label}
    </Button>
  );
}

function Footer() {
  return (
    <footer className={styles.footer}>
      <Text className="mb-0">&copy; All rights reserved by Kraal Ltd.</Text>
      <Flex className={styles['link-wrapper']} wrap>
        <FooterLink to="/auth/privacy" label="Privacy Policy" />
        <FooterLink to="/auth/terms" label="Terms and Conditions" />
      </Flex>
    </footer>
  );
}

export default memo(Footer);
